var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologyWireless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -1710.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/Wireless",
    transform: "translate(3880.000000, 1710.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,21 C17.933,21 19.5,22.567 19.5,24.5 C19.5,26.433 17.933,28 16,28 C14.067,28 12.5,26.433 12.5,24.5 C12.5,22.567 14.067,21 16,21 Z M16.0001,11.8835 C19.9886517,11.8835 23.6322807,13.3247176 26.4674469,15.7004089 L26.7681,15.9585 L23.7501,19.3535 C21.6691,17.5315 18.9771,16.3885 16.0001,16.3885 C13.1471417,16.3885 10.5559281,17.4382344 8.51338371,19.12932 L8.2501,19.3535 L5.2321,15.9585 C8.1081,13.4295 11.8691,11.8835 16.0001,11.8835 Z M16,3.9999 C21.975027,3.9999 27.4284354,6.18198912 31.6509853,9.7706091 L32,10.0729 L29.004,13.4429 C25.53,10.3799 20.985,8.5049 16,8.5049 C11.1707813,8.5049 6.75449219,10.2645436 3.32480594,13.1592452 L2.996,13.4429 L0,10.0729 C4.269,6.3049 9.859,3.9999 16,3.9999 Z",
    id: 287
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologyWireless);
export default __webpack_public_path__ + "static/media/device-and-technology-wireless.f77a5272.svg";
export { ForwardRef as ReactComponent };